import React from 'react';
import { CheckboxGroup as RCheckboxGroup } from 'rsuite';
import { CheckboxGroupProps as RCheckboxGroupProps } from 'rsuite/lib/CheckboxGroup';

export type CheckboxGroupProps = RCheckboxGroupProps;

export const CheckboxGroup = (props: CheckboxGroupProps) => {
  return <RCheckboxGroup {...props} />;
};
